import { ClassroomState } from "@/models";
import students from "./Students";
import { Grade } from "@/enums";

export const ClassroomStoreMock: ClassroomState = {
  id: '2915137',
  grade: Grade.KINDERGARTEN,
  students: students,
  loading: false,
  error: null,
}

export default ClassroomStoreMock;